import { useState } from "react";
import ModalTwoButtons from "../../../components/Modal/ModalTwoButtons";
import { ValidateEmailAddressTextField } from "../../../components/ValidateEmailAddressTextField";
import { ValidationStatus } from "../../../components/ValidationTextField";
import { Typography } from "@mui/material";
import { useUser } from "../../../context/UserContext";
import EmailAddressTextField from "../../../components/EmailAddressField";

interface AssignBlenderModalProps {
  display: boolean;
  onOk: (validEmail: string) => void;
  onCancel?: () => void;
}

export const AssignBlenderModal: React.FC<AssignBlenderModalProps> = ({
  display = false,
  onOk,
  onCancel,
}) => {
  const { isGuestUser } = useUser();
  const [email, setEmail] = useState<string>("");
  const [status, setStatus] = useState<ValidationStatus>("idle");
  const label = "Blender Email";

  const resetComponentState = () => {
    setEmail("");
    setStatus("idle");
  };

  const handleOkClick = () => {
    if (status !== "valid") return;
    onOk(email);
    resetComponentState();
  };

  const handleCancelClick = () => {
    onCancel?.();
    resetComponentState();
  };

  const handleSetErrorsForEmailSearchField = (hasErrors: boolean | null) => {
    if (hasErrors === true) {
      setStatus("invalid");
      return;
    }

    if (hasErrors === false) {
      setStatus("valid");
      return;
    }

    setStatus("idle");
  };

  return (
    <ModalTwoButtons
      title={"Set Blender"}
      button1Text={"Ok"}
      button1Action={handleOkClick}
      isButton1Disabled={status !== "valid"}
      button2Text={"Cancel"}
      button2Action={handleCancelClick}
      isButton2Disabled={false}
      open={display}
      setOpen={undefined}
      setClose={undefined}>
      <Typography variant="caption" sx={{ mb: 2, display: "block" }}>
        Enter the email address of the blender you want to assign.
      </Typography>
      {isGuestUser ? (
        <ValidateEmailAddressTextField
          label={label}
          placeholder={"Enter exact Blender Email"}
          value={email}
          onChange={setEmail}
          onStatusChange={setStatus}
          showPlusMeButton={true}
        />
      ) : (
        <EmailAddressTextField
          labelText={label}
          placeholderText="Blender Email"
          validatedUserEmail={email}
          setValidatedUserEmail={setEmail}
          setHasErrors={handleSetErrorsForEmailSearchField}
          isDisabled={false}
          showPlusMeButton={true}
          fieldWidth={"350px"}
          size="small"
          margin="normal"
        />
      )}
    </ModalTwoButtons>
  );
};
